var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "other"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      rules: _vm.rules,
      model: _vm.dataForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "phoneSmsLimit"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.phoneSmsLimit")) + " "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.phoneSmsLimitPrompt")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input-number", {
    staticClass: "cfinput_class",
    staticStyle: {
      width: "60%"
    },
    attrs: {
      min: 1,
      max: 99999,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.phoneSmsLimit,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "phoneSmsLimit", $$v);
      },
      expression: "dataForm.phoneSmsLimit"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "ipSmsLimit"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.ipSmsLimit")) + " "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.ipSmsLimitPrompt")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input-number", {
    staticClass: "cfinput_class",
    staticStyle: {
      width: "60%"
    },
    attrs: {
      min: 1,
      max: 99999,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.ipSmsLimit,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "ipSmsLimit", $$v);
      },
      expression: "dataForm.ipSmsLimit"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "remindSmsLimit"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.remindSmsLimit")) + " "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.remindSmsLimitPrompt")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input-number", {
    staticClass: "cfinput_class",
    staticStyle: {
      width: "60%"
    },
    attrs: {
      min: 1,
      max: 99999,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.remindSmsLimit,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remindSmsLimit", $$v);
      },
      expression: "dataForm.remindSmsLimit"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "maxLoginNumber"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.maxLoginNum")) + " "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.maxLoginNumPrompt")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input-number", {
    staticClass: "cfinput_class",
    staticStyle: {
      width: "60%"
    },
    attrs: {
      min: 1,
      max: 99999,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.maxLoginNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "maxLoginNumber", $$v);
      },
      expression: "dataForm.maxLoginNumber"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "orderAmountShowDays"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.orderamountShowdays")) + " "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.orderamountShowdays")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input-number", {
    staticClass: "cfinput_class",
    staticStyle: {
      width: "60%"
    },
    attrs: {
      min: 1,
      max: 99999,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.orderAmountShowDays,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "orderAmountShowDays", $$v);
      },
      expression: "dataForm.orderAmountShowDays"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.clientLanguageDisplay"),
      prop: "clientLanguageDisplayIds"
    }
  }, [_c("a-checkbox-group", {
    attrs: {
      options: _vm.clientLanguageDisplayList
    },
    model: {
      value: _vm.dataForm.clientLanguageDisplayIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "clientLanguageDisplayIds", $$v);
      },
      expression: "dataForm.clientLanguageDisplayIds"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.shopDefaultLanguage")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "60%"
    },
    attrs: {
      disabled: true,
      maxLength: 100,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.shopDefaultLanguage,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "shopDefaultLanguage", $$v);
      },
      expression: "dataForm.shopDefaultLanguage"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.BaiduTranslateappid")
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.baiduTranslateAppid,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "baiduTranslateAppid", $$v);
      },
      expression: "dataForm.baiduTranslateAppid"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.BaiduTranslateappscript")
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true
    },
    model: {
      value: _vm.dataForm.baiduTranslateAppscript,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "baiduTranslateAppscript", $$v);
      },
      expression: "dataForm.baiduTranslateAppscript"
    }
  })], 1), _vm._l(_vm.dataForm.arrivalTimeReminderList, function (item, index) {
    return _c("div", {
      staticStyle: {
        position: "relative"
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: item.languageName
      }
    }, [_c("a-textarea", {
      attrs: {
        rows: 2,
        allowClear: true,
        maxLength: 1000
      },
      on: {
        focus: function focus($event) {
          return _vm.showFYBtn(item);
        }
      },
      model: {
        value: item.content,
        callback: function callback($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    })], 1), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("public.translate")) + " ")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.showFY,
        expression: "item.showFY"
      }],
      staticStyle: {
        width: "20px",
        top: "44px",
        right: "-25px",
        position: "absolute",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.fanyiPic
      }
    })], 2)], 1);
  }), _vm._l(_vm.dataForm.leaveWordReminderList, function (item, index) {
    return _c("div", {
      staticStyle: {
        position: "relative"
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: item.languageName
      }
    }, [_c("a-textarea", {
      attrs: {
        rows: 2,
        allowClear: true,
        maxLength: 1000
      },
      on: {
        focus: function focus($event) {
          return _vm.showFYBtn(item);
        }
      },
      model: {
        value: item.content,
        callback: function callback($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    })], 1), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("public.translate")) + " ")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.showFY,
        expression: "item.showFY"
      }],
      staticStyle: {
        width: "20px",
        top: "44px",
        right: "-25px",
        position: "absolute",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.fanyiPic
      }
    })], 2)], 1);
  })], 2), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };